import Component from './AcceptRequestedOffers'

export default Component
